import { createApiCall } from 'lib/base';
import { generateEndpoint } from '@ngtrvu/use-api';

const apiCall = type => {
  const FETCH_INVESTCORE_DATA_LIST_API_ID = `DASHBOARD/FETCH_INVESTCORE_DISTRICTS_${type}`;

  return createApiCall(FETCH_INVESTCORE_DATA_LIST_API_ID, params => ({
    endpoint: generateEndpoint({
      host: `/api/admin/districts`,
      params,
    }),
    method: 'GET',
  }));
};

export default apiCall;
